export const ActivePointDalli = () => (
	<svg width="115" height="124" viewBox="0 0 115 124" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_ddd_25188_21648)">
			<path
				d="M85.793 62.375C85.793 83.2188 61.793 95 61.793 95C61.793 95 37.793 82.7656 37.793 62.375C37.793 48.3608 48.5381 37 61.793 37C75.0478 37 85.793 48.3608 85.793 62.375Z"
				fill="white"
			/>
		</g>
		<path
			d="M70.4428 66.2766C69.8752 66.229 69.333 66.0236 68.8791 65.6844C68.8304 65.6489 68.7736 65.6256 68.7138 65.6164C68.6539 65.6073 68.5927 65.6125 68.5353 65.6317C68.4779 65.6509 68.4261 65.6835 68.3843 65.7267C68.3424 65.7699 68.3118 65.8224 68.295 65.8797C67.9115 67.1118 67.2589 68.2461 66.383 69.2028C66.3466 69.2423 66.3194 69.2893 66.303 69.3402C66.2868 69.3912 66.2819 69.445 66.2887 69.498C66.2956 69.551 66.314 69.6019 66.3427 69.6473C66.3714 69.6926 66.4097 69.7313 66.455 69.7606C67.6047 70.4986 68.9322 70.923 70.3024 70.9906C70.3536 70.9932 70.4048 70.9854 70.4528 70.9679C70.501 70.9503 70.5449 70.9233 70.5821 70.8885C70.6192 70.8537 70.6489 70.8119 70.6691 70.7655C70.6894 70.7191 70.6999 70.6691 70.7 70.6186V66.5532C70.7001 66.4836 70.6737 66.4167 70.6261 66.3655C70.5784 66.3142 70.513 66.2825 70.4428 66.2766ZM67.6299 49.3461C67.6299 49.3006 67.6209 49.2556 67.6032 49.2136C67.5856 49.1715 67.5596 49.1334 67.527 49.1012C67.4944 49.0691 67.4557 49.0436 67.413 49.0262C67.3704 49.0089 67.3247 48.9999 67.2785 49H63.1998C63.1067 49 63.0174 49.0365 62.9516 49.1014C62.8858 49.1663 62.8487 49.2543 62.8487 49.3461V63.4352C62.8534 63.9501 62.7123 64.4562 62.4413 64.8965C62.1704 65.3368 61.7803 65.6938 61.3149 65.9277C59.0399 67.0357 56.7804 65.421 56.7804 63.2958C56.7803 62.7843 56.9133 62.2813 57.1667 61.8348C57.42 61.3884 57.7853 61.0135 58.2276 60.746C58.6699 60.4785 59.1745 60.3273 59.6929 60.3069C60.2114 60.2864 60.7265 60.3975 61.1891 60.6293C61.2465 60.6595 61.3108 60.6745 61.3758 60.673C61.4408 60.6714 61.5043 60.6533 61.5602 60.6205C61.616 60.5876 61.6623 60.5411 61.6946 60.4855C61.7269 60.4298 61.7439 60.3669 61.7443 60.3027V56.1796C61.7442 56.0782 61.7086 55.9801 61.6435 55.9016C61.5785 55.8231 61.4879 55.7692 61.3872 55.7489C60.2514 55.5192 59.0778 55.5415 57.9517 55.8142C56.8256 56.087 55.7752 56.6033 54.8765 57.3257C53.9779 58.0482 53.2535 58.9587 52.756 59.9913C52.2585 61.0239 52.0003 62.1527 52 63.2958C52 68.4223 57.1052 72.3953 62.5667 70.5332C65.6231 69.4913 67.6295 66.5979 67.6295 63.4101L67.6299 49.3461Z"
			fill="#002A47"
		/>
		<defs>
			<filter
				id="filter0_ddd_25188_21648"
				x="0.792969"
				y="0"
				width="114"
				height="124"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="8" />
				<feGaussianBlur stdDeviation="5" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25188_21648" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.05 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_25188_21648" result="effect2_dropShadow_25188_21648" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="-4" dy="-4" />
				<feGaussianBlur stdDeviation="16.5" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
				<feBlend mode="normal" in2="effect2_dropShadow_25188_21648" result="effect3_dropShadow_25188_21648" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_25188_21648" result="shape" />
			</filter>
		</defs>
	</svg>
)
